import React from 'react';
import styles from './systemStatus.module.css';


const STATUS_NAMES = ['', 'Normal', 'Not Enough Business', 'Closed Access'];

export const SystemStatus = ({
    status,
    showName = false,
}) => {
    return <div className={styles.SystemStatusWrapper} title={STATUS_NAMES[status]}>
        <div className={styles.SystemStatus + ' ' + styles['Status-' + status]}></div>
        {showName && <div className={styles.SystemStatusName}>{STATUS_NAMES[status]}</div>}
    </div>
}